import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress errors from browser extensions (like MetaMask)
// These are not bugs in our app - they come from user's browser extensions
window.addEventListener('error', (event) => {
  if (event.message && (
    event.message.includes('MetaMask') ||
    event.message.includes('chrome-extension') ||
    event.message.includes('moz-extension')
  )) {
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && (
    event.reason.message.includes('MetaMask') ||
    event.reason.message.includes('chrome-extension') ||
    event.reason.message.includes('moz-extension')
  )) {
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
